import React from 'react';
import { LoadingPlaceholder } from '../client-web-app/components';
import { CLIENT_YEARLY_DATA } from './queries';
import YearEndFinancialLabel from './yearEndFinancialLabel';
import { useQuery } from '@apollo/client';

type YearlyData = {
  year: string | undefined;
  yearEndFinancialPackage: string | undefined;
};

const LastCompletedYEFYear = (props: { clientId: string }) => {
  const { clientId } = props;
  const { loading, error, data } = useQuery(CLIENT_YEARLY_DATA, {
    variables: { clientId },
  });
  if (error) {
    return <div>{error.message}</div>;
  }
  if (loading) {
    return <LoadingPlaceholder minHeight={10} />;
  }
  const { client } = data;
  const { yearlyData } = client;
  const lastCompletedYEF = getLastCompletedYEF(yearlyData);
  const text = `Last completed YEF year: ${lastCompletedYEF?.year || 'Does Not Exist'}`;

  return <YearEndFinancialLabel text={text} />;
};

function getLastCompletedYEF(documents: YearlyData[]) {
  const filteredDocuments = documents.filter(y => y.yearEndFinancialPackage === 'COMPLETE');
  filteredDocuments.sort((a, b) => {
    const dateA = a.year ? new Date(a.year) : undefined;
    const dateB = b.year ? new Date(b.year) : undefined;
    return dateB && dateA ? dateB.getTime() - dateA.getTime() : 0;
  });
  const yef = filteredDocuments[0];
  return yef;
}

export default LastCompletedYEFYear;
